import React, { useEffect } from "react"
import { CssBaseline } from "@mui/material"
import { CookieBanner } from "../../components/CookieBanner/CookieBanner"
import { PageDataProvider } from "../../hooks/usePageData"
import { useBETelemetry } from "../../hooks/useTelemetry"
import useUser from "@talentinc/gatsby-theme-ecom/hooks/useUser"
import { BrandNames } from "../../types/brand"
import { PageDataContextType } from "../../types/page"
import { useMixpanelIdentityManagement } from "../../utils/mixpanel"
import Identify from "../Impact/Identify"
import PromoBanner from "../PromoBanner/PromoBanner"
import BannerProvider from "../Providers/Banner"
import XRayDrawer from "../XRay/XRayDrawer"
import Head from "./Head"
import CookieConsentComponent from "@talentinc/gatsby-theme-ecom/components/CookieConsent"

interface LayoutProps {
  pageTitle?: string
  pageData: PageDataContextType
  children: React.ReactNode
  disableHelmet?: boolean
}

const Layout: React.FC<LayoutProps> = ({ children, pageTitle, pageData, disableHelmet = false }) => {
  useMixpanelIdentityManagement()

  const telemetry = useBETelemetry()
  const { sessionID, isLoading } = useUser()

  const isTopResume = pageData.brand.name.toLowerCase() === BrandNames.topResume
  const isZipJob = pageData.brand.name.toLowerCase() === BrandNames.zipJob
  const isTopCV = pageData.brand.name.toLowerCase() === BrandNames.topCv

  useEffect(() => {
    if (!isLoading && sessionID) {
      telemetry.track({ event: "page_view" })
    }
  }, [isLoading, sessionID, telemetry])

  return (
    <>
      <PageDataProvider {...pageData}>
        <Head
          pageTitle={pageTitle}
          locale={pageData.locales && pageData?.locales?.edges?.[0]?.node?.language}
          disableHelmet={disableHelmet}
        />
        <CssBaseline />
        <XRayDrawer>
          {(isTopResume || isZipJob || isTopCV) && <Identify />}
          <BannerProvider>
            <PromoBanner />
            {children}
            {!isZipJob && <CookieConsentComponent />}
          </BannerProvider>
        </XRayDrawer>
      </PageDataProvider>
      {isZipJob && <CookieBanner />}
    </>
  )
}

export default Layout
